import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Calculator, Ruler } from "lucide-react";

const PedestrianEntranceControl = ({ onBack }) => {
  const navigate = useNavigate();

  const modules = [
    {
      id: 'comet-speedlane',
      title: 'Comet Speedlane',
      icon: Calculator,
      color: 'from-green-500 to-green-600',
      hoverColor: 'hover:from-green-600 hover:to-green-700',
      navigate: '/configurator',
      available: true
    },
    {
      id: 'space-configurator',
      title: 'Space Configurator',
      icon: Ruler,
      color: 'from-indigo-500 to-blue-600',
      hoverColor: 'hover:from-indigo-600 hover:to-blue-700',
      navigate: '/space-configurator',
      available: true,
      isNew: true
    },
    {
      id: 'half-height-turnstiles',
      title: 'Half Height Turnstiles',
      icon: Calculator,
      color: 'from-teal-500 to-cyan-600',
      hoverColor: 'hover:from-teal-600 hover:to-cyan-700',
      navigate: '/half-height-turnstiles',
      available: true
    },
    {
      id: 'full-height-turnstiles',
      title: 'Full Height Turnstiles',
      icon: Calculator,
      color: 'from-orange-500 to-yellow-500',
      hoverColor: 'hover:from-orange-600 hover:to-yellow-600',
      navigate: '/full-height-turnstiles',
      available: true
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 p-8">
      <div className="max-w-6xl mx-auto">
        {/* Back Button */}
        <Button
          variant="ghost"
          onClick={onBack}
          className="mb-6 text-slate-600 hover:text-slate-900"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Dashboard
        </Button>

        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex justify-center mb-4">
            <img src="/zkteco-logo.png" alt="ZKTeco" className="h-24 w-auto" />
          </div>
          <h1 className="text-3xl font-bold text-slate-800 mb-2">
            Pedestrian Entrance Control
          </h1>
          <p className="text-lg text-slate-600">
            Select a configurator to get started
          </p>
        </div>

        {/* Modules Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {modules.map((module) => {
            const Icon = module.icon;
            return (
              <button
                key={module.id}
                onClick={() => module.available && navigate(module.navigate)}
                className={`group relative overflow-hidden ${!module.available ? 'cursor-not-allowed' : ''}`}
                disabled={!module.available}
              >
                <Card className={`border-2 border-slate-200 ${module.available ? 'hover:border-green-500' : 'opacity-75'} transition-all duration-300 h-56`}>
                  <CardContent className="p-0 h-full">
                    <div className={`h-full bg-gradient-to-br ${module.color} ${module.available ? module.hoverColor : ''} transition-all duration-300 flex flex-col items-center justify-center text-white relative overflow-hidden`}>
                      {/* New Badge */}
                      {module.isNew && (
                        <div className="absolute top-4 right-4 z-20">
                          <div className="px-3 py-1 rounded-full bg-yellow-400 text-yellow-900 text-xs font-bold shadow-lg">
                            NEW
                          </div>
                        </div>
                      )}
                      {/* Coming Soon Badge */}
                      {!module.available && (
                        <div className="absolute top-4 right-4 z-20">
                          <div className="px-3 py-1 rounded-full bg-white/20 backdrop-blur-sm text-xs font-semibold">
                            Coming Soon
                          </div>
                        </div>
                      )}
                      
                      {/* Decorative background pattern */}
                      <div className="absolute inset-0 opacity-10">
                        <div className="absolute top-0 left-0 w-32 h-32 border-4 border-white rounded-full -translate-x-16 -translate-y-16"></div>
                        <div className="absolute bottom-0 right-0 w-32 h-32 border-4 border-white rounded-full translate-x-16 translate-y-16"></div>
                      </div>
                      
                      {/* Icon */}
                      <div className={`relative z-10 mb-4 transform ${module.available ? 'group-hover:scale-110' : ''} transition-transform duration-300`}>
                        <div className="w-16 h-16 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center border-2 border-white/50">
                          <Icon className="w-8 h-8" />
                        </div>
                      </div>
                      
                      {/* Text */}
                      <div className="relative z-10 text-center px-4">
                        <h3 className="text-lg font-bold">
                          {module.title}
                        </h3>
                      </div>
                      
                      {/* Hover effect */}
                      {module.available && (
                        <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-10 transition-opacity duration-300"></div>
                      )}
                    </div>
                  </CardContent>
                </Card>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default PedestrianEntranceControl;
